<template>
  <a-layout class="index-page" :style="containerStyle">
    <a-layout-header class="index-header">
      <div class="index-header-box">
        <div class="index-header-left">
          <img src="../../public/static/index/logo.png" alt="">
          <span class="index-name">{{ companyName }}</span>
        </div>
        <nav class="navbar">
          <div class="menu-toggle" id="menu-toggle" @click="toggleMenu" :aria-expanded="isMenuOpen" aria-controls="index-nav">
            ☰
          </div>
          <ul class="index-nav" id="index-nav" :class="{ 'show': !isMenuOpen }">
            <li v-for="(item, index) in navItems" :key="index" class="menu-item menu-item-only-child" @click="goToAnchor(item.anchor)">
              <span v-if="!item.isButton">{{ item.text }}</span>
              <a-button v-else type="primary" shape="round" class="index-btn" @click.stop="goToAnchor(item.anchor)">
                {{ item.text }}
              </a-button>
            </li>
          </ul>
        </nav>
      </div>
    </a-layout-header>
    <a-layout-content class="index-content">
      <a-carousel autoplay>
        <div id="home" class="index-carousel" v-for="(item, index) in arrImg" :key="index">
          <img :src="item.imgUrl" :alt="item.title"/>
          <div class="index-carousel-text" >
            <div v-if="item.className === 'banner-main'" class="banner-main">
              <div class="banner-main-box">
                <span>法</span>
                <div>方法，创新的思维</div>
              </div>
              <div class="banner-main-box">
                <span>法</span>
                <div>法力，强力的执行</div>
              </div>
            </div>
            <div class="banner-other">
              <div class="banner-other-title">{{ item.title }}</div>
              <div class="banner-other-text">{{ item.description}}</div>
            </div>
          </div>
        </div>
      </a-carousel>
      <section id="about" class="index-company parallax">
        <div class="index-company-title">{{ companyName }}</div>
        <div class="index-company-subtitle">{{ companyNameEn }}</div>
        <div class="index-bar"></div>
        <div class="index-info">
          {{ companyInfo }}
        </div>
      </section>
      <section id="project" class="project-bg parallax">
        <div class="index-project-title">
          <span>{{ projectTitle }}</span>
        </div>
        <div class="index-project-subtitle">{{ projectSubTitle }}</div>
      </section>
      <section class="index-project project-bg parallax">
        <div class="index-project-box">
          <div class="index-project-info">
            <div class="index-project-info-name">{{ projectSubTitle }}</div>
            <div class="index-project-info-desc">
              {{chainProjectInfo}}
            </div>
          </div>
          <div class="index-project-img">
            <img src="../../public/static/index/chainProject.png" alt="">
          </div>
        </div>
        <div class="index-project-card">
          <a-card hoverable v-for="(item, index) in chainProjectCards" :key="index" >
            <template #cover>
              <img :src="item.image" :alt="item.title">
            </template>
            <a-card-meta :title="item.title">
              <template #description>{{ item.description }}</template>
            </a-card-meta>
          </a-card>
        </div>
      </section>
      <section class="index-project project-bg-white parallax">
        <div class="index-project-box">
          <div class="index-project-img">
            <img src="../../public/static/index/wholesaleProject.png" alt="">
          </div>
          <div class="index-project-info">
            <div class="index-project-info-name">{{ wholesaleTitle }}</div>
            <div class="index-project-info-desc">
              {{ wholesaleInfo }}
            </div>
          </div>
        </div>
        <div class="index-project-card-row">
          <a-card hoverable v-for="(item, index) in wholesaleProjectCards" :key="index" >
            <template #cover>
              <img :src="item.image" :alt="item.title">
            </template>
            <a-card-meta :title="item.title">
              <template #description>{{ item.description }}</template>
            </a-card-meta>
          </a-card>
        </div>
      </section>
      <section class="index-project project-bg parallax">
        <div class="index-project-box">
          <div class="index-project-info">
            <div class="index-project-info-name">{{ groupMealTitle }}</div>
            <div class="index-project-info-desc">
              {{ groupMealInfo }}
            </div>
          </div>
          <div class="index-project-img">
            <img src="../../public/static/index/groupMeal.png" alt="">
          </div>
        </div>
        <div class="index-project-card-row">
          <a-card hoverable v-for="(item, index) in groupMealProjectCards" :key="index" >
            <template #cover>
              <img :src="item.image" :alt="item.title">
            </template>
            <a-card-meta :title="item.title">
              <template #description>{{ item.description }}</template>
            </a-card-meta>
          </a-card>
        </div>
      </section>
      <section class="index-project project-bg-white parallax">
        <div class="index-project-box">
          <div class="index-project-img">
            <img src="../../public/static/index/internet.png" alt="">
          </div>
          <div class="index-project-info">
            <div class="index-project-info-name">{{ internetTitle }}</div>
            <div class="index-project-info-desc">
              {{internetInfo}}
            </div>
          </div>
        </div>
        <div class="index-project-card-row">
          <a-card hoverable v-for="(item, index) in internetProjectCards" :key="index" >
            <template #cover>
              <img :src="item.image" :alt="item.title">
            </template>
            <a-card-meta :title="item.title">
              <template #description>{{ item.description }}</template>
            </a-card-meta>
          </a-card>
        </div>
      </section>
      <section id="customer" class="parallax project-bg">
        <div class="index-customer-title">{{ partner }}</div>
        <div class="index-customer-subtitle">{{ companyName }}</div>
        <div class="index-customer-box">
          <a-card class="index-customer-card" v-for="(item, index) in logoCards" :key="index">
            <img class="index-customer-img" :src="item.image" :alt="item.title">
          </a-card>
        </div>
      </section>
    </a-layout-content>
    <a-layout-footer id="contact" class="index-footer">
      <div class="index-footer-box">
        <div class="index-footer-title">
          <img class="index-footer-logo" src="../../public/static/index/FAFALogo.png" alt="">
          <div class="index-footer-company">{{ companyName }}</div>
        </div>
        <div class="index-footer-grid">
          <div v-for="(item, index) in navItems" :key="index" @click="goToAnchor(item.anchor)">{{ item.text}}</div>
        </div>
        <div class="index-footer-contact">
          <div class="index-footer-contact-text">{{ addressName }}</div>
          <div class="index-footer-contact-text">{{ address }}</div>
          <div class="index-footer-contact-text">{{ contact }}</div>
          <div class="index-footer-contact-text">{{ telPhone }}</div>
          <div class="index-footer-contact-text">{{ webName }}</div>
          <div class="index-footer-contact-text">{{ web }}</div>
        </div>
        <div class="index-footer-code">
          <div>{{ weChat }}：{{ companyAbbr }}</div>
          <img src="../../public/static/index/FAFACode.png" alt="">
        </div>
      </div>
      <div class="index-footer-number">
        <span>&copy; 上海法法信息技术有限公司</span>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702006729"
           style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left: 20px;"><img src="../../public/static/icon/beian.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#FFFFFF;">沪公网安备 31011702006729号</p></a>
        <a target="_blank" href="http://beian.miit.gov.cn" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left: 20px;"><p
          style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#FFFFFF;">沪ICP备05022780号</p></a>
      </div>
    </a-layout-footer>
  </a-layout>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      isMenuOpen: true,
      navItems: [
        { text: '首页', anchor: '#home' },
        { text: '关于我们', anchor: '#about' },
        { text: '解决方案', anchor: '#project' },
        { text: '合作客户', anchor: '#customer' },
        { text: '联系我们', anchor: '#contact', isButton: true },
      ],
      partner:'合作客户',
      project:'解决方案',
      customer:'合作客户',
      contact:'联系我们',
      introduction:'产品介绍',
      customerCase:'客户案例',
      implement:'实施流程',
      addressName:'公司地址',
      address:'上海市莘砖公路668号G60科创大厦A座603',
      telPhone:'021-51870609',
      webName:'网址',
      web:'www.fafa.com.cn',
      weChat:'微信',
      companyAbbr:'法法信息',
      companyName:'上海法法信息技术有限公司',
      companyNameEn: 'Shanghai Two-Ways Information Technology Co.,Ltd',
      companyInfo: '上海法法成立于2004年，核心成员具备深厚的零售行业经验及咨询公司工作经历，我们以软件定制服务为核心，\n以合伙人的态度伴随客户成长。公司总部位于上海、杭州、西安设立开发中心。\n秉承创新、高效、实用、担当的企业文化、坚持小团队特种兵的工作模式，具备成熟稳定的软件开发团队，丰富的项目交付经验，我们的项目落地成功率接近100%。',
      projectTitle: '解决方案',
      projectSubTitle: '连锁零售行业一体化解决方案',
      chainProjectInfo:'全方位覆盖连锁零售企业全业务环节，包含供应链、门店零售、会员权益。支持多级组织架构、多种门店模式的管理体系；支持美团、饿了么、抖音等本地生活接入；支持供应商平台，智能配补等供应链优化能力；支持多语言、多货币、多时区的国际门店拓展；支持ERP、WMS、财务、BI、CRM、电商等各类软件集成。\n \n根据企业实际业务提供定制服务，成为随需而变的零售企业信息化合伙人。',
      wholesaleTitle:'批发分销解决方案',
      wholesaleInfo:'专为批发零售行业提供从供应商管理，仓库管理、销售管理、营销管理、商城管理、客户管理到经营数据分析等场景解决方案，助力零售行业伙伴高效构建数字化应用，全面实现数字化业务在线和管理在线。\n通过授权相关业务管理权限，提升各分销渠道自主管理能力。移动前端，转化新老客户巨大传播能量，快速扩展移动分销',
      groupMealTitle:'团餐食堂解决方案',
      groupMealInfo:'系统覆盖团餐管理全流程，通过智能硬件和云端服务实现对食堂的采购、生产、售卖、经营分析、活动评价等全流程服务管理。适用于档口点餐、自助餐、自选餐等食堂场景。\n提供线上预订点餐、自助结算等功能，通过人脸识别和菜品识别技术，实现快速自助结算，减少排队等待时间，提升就餐体验优化点餐、结算流程，提高服务水平和管理效率‌。',
      internetTitle:'互联网应用定制开发',
      internetInfo:'满足客户各行业领域中对不同应用有个性化需求，而进行的量身定制的应用开发，更快速、便捷且可扩展的推动企业数字化转型，包括企业内部管理、客户服务、移动商城、活动营销、餐饮服务、移动巡查等。\n',

      arrImg:[
        { imgUrl: require('../../public/static/index/banner1.png'),
          className:'banner-main',
        },
        { imgUrl: require('../../public/static/index/banner2.png'),
          className:'banner-other',
          title:'批发分销解决方案',
          description:'关注运营效率，管理焦点，适合初具规模分销企业',
        },
        { imgUrl: require('../../public/static/index/banner3.png'),
          className:'banner-other',
          title:'批发分销解决方案',
          description:'关注运营效率，管理焦点，适合初具规模分销企业',
        },
        { imgUrl: require('../../public/static/index/banner4.png'),
          className:'banner-other',
          title:'连锁零售解决方案',
          description:'20多年的沉淀，打造专属于您的一体化业务系统',
        },
        { imgUrl: require('../../public/static/index/banner5.png'),
          className:'banner-other',
          title:'餐饮团餐解决方案',
          description:'关注员工，应用在多家世界500强企业团餐信息化方案',
        },
      ],
      chainProjectCards:[
        {
          image: require('../../public/static/index/Kellan.png'),
          title: '凯蓝集团',
          description: '凯蓝集团现有绿光派对、伶俐、兰诺、茉荔屋、朴淘、头号抓手等品牌，15家分公司，3000+直营门店，其中海外门店近100家。主营饰品、生活家居、潮玩。我们从2008年建立合作，当时门店200家，16年来，我们见证和伴随了凯蓝的成功。合作范围：全业务系统。'
        },
        {
          image: require('../../public/static/index/MCAQLO.png'),
          title: '米咔库连锁',
          description: '作为全球IP文创零售连锁品牌，米咔库与迪士尼、王者荣耀、超级飞侠等众多知名IP的合作，公司为上述产品授权生产商，2024年在原有基础上拓展连锁零售门店，拓展IP连锁店体系。法法为米咔库提供零售系统、供应链系统、CRM权益结算平台、支持自营及加盟体系，系统和SAP集成。'
        },
        {
          image: require('../../public/static/index/IRA.png'),
          title: '爱朗男装',
          description: '爱朗男装成立于2014年，总部位于南京，目前共有门店400+，包含2个品牌。法法于2016年和爱朗建立合作，为爱朗建立了供应链管理、门店收银、会员体系等核心业务系统，结合实际业务建立的智能配货体系，极大提升了门店周转率及商品售罄率。软件集成：用友、帆软、OA。'
        },
        {
          image: require('../../public/static/index/JuneERP.png'),
          title: '六月国际',
          description: '六月国际采购中心位于中国义乌，目前门店分布在危地马拉、尼加拉瓜、洪都拉斯等国家，现有门店50+，法法于2024年5月和六月国际建立合作，为其建立核心业务系统，主要包含采购体系，国际及国内配送管理，各国商品管理体系，门店零售、门店分销体系，多货币多时区多语言国际版本。'
        },
        {
          image: require('../../public/static/index/ALDI.png'),
          title: '奥乐齐门店PDA系统',
          description: '奥乐齐为全球知名生鲜超市品牌，我们于2018年开始奥乐齐中国区门店提供PDA全面解决方案，包含收货、要货、调价、盘点、调拨、查询等业务，精准掌控库存，提升管理效率，优化业务流程，有力推动超市管理的智能化、信息化进程。'
        },
        {
          image: require('../../public/static/index/Leyin.png'),
          title: '乐茵婴童',
          description: '乐婴总部位于江苏江阴，区域性母婴连锁，门店100+，于2017年上线法法的连锁管理系统，包含采购、配送、仓库、门店等业务，会议系统、会员商城集成第三方系统。'
        },
      ],
      wholesaleProjectCards:[
        {
          image: require('../../public/static/index/Anchor.png'),
          title: '安佳乳品移动商城解决方案',
          description: '为安佳乳品门店打造专属的移动端采购平台。通过此商城，门店人员可轻松完成下单操作，管理后台可根据门店采购数据进行分析，有效提升安佳乳品门店采购的效率与精准度，满足门店日常运营需求。'
        },
        {
          image: require('../../public/static/index/FangYu.png'),
          title: '上海方予批发分销解',
          description: '上海方予实业是一家专门为各大超市门店做批发业务的公司，主要经营项目有调味品和冲调饮品等。现有批发客户接近3000家，业务人员30+，每日开单300+。从2008年开始，我们持续为其提供信息化服务，提供了采购、分销、结算、仓库、装车派车等全套业务系统，包含电脑端、PDA端、手机小程序等，全方位为方予提高运营效率，达成业务精细化管理。'
        },
        {
          image: require('../../public/static/index/IRA.png'),
          title: '上海伊利牛奶分销',
          description: '上海伊利牛奶分销商，主要经营伊利牛奶、奶粉业务，客户对象为大润发等大卖场及小型商超，我们2010年开始为其提供核心业务管理系统，结合大卖场实际业务，定制了开单体系、发票结算体系、食品批次管理方案。'
        },
      ],
      groupMealProjectCards:[
        {
          image: require('../../public/static/index/Sodexo.png'),
          title: '索迪斯软件服务供应商',
          description: '法法作为索迪斯优选软件服务供应商，为其提供团餐、生活服务、设施管理、屏幕信发等领域软件服务，10年来，配合索迪斯为强生、阿斯利康、罗氏、联合利华、中欧商学院等客户提供软件服务。'
        },
        {
          image: require('../../public/static/index/Microsoft.png'),
          title: '微软餐厅解决方案',
          description: '我们为微软中国园区员工食堂提供一系列就餐解决方案，通过小程序提供包括食堂就餐、在线订餐、自助充值、咖啡吧和超市等构建具有统一性，实现各种复杂规则的综合管理平台。'
        },
        {
          image: require('../../public/static/index/Covestro.png'),
          title: '科思创食堂解决方案',
          description: '科思创是一家总部位于德国的化学工业公司，我们为科思创(中国)提供员工食堂解决方案，通过手机端提供菜品投票、食堂积分活动、员工点评、服务评价等活动，帮助提高员工就餐体验。'
        },
      ],
      internetProjectCards:[
        {
          image: require('../../public/static/index/SUIS.png'),
          title: '上海协和双语学校校园解决方案',
          description: '学生学业报告系统、期中期末老师评语、点名签到、作业批改管理、入学信息填报、家校通和校园访客等，全方位优化校园管理与沟通，提升教学质量和效率，打造数字化、智能化、精细化的校园环境。'
        },
        {
          image: require('../../public/static/index/CONTCIRCLE.png'),
          title: '箱通网国际集装箱租赁交易平台',
          description: '通过国际集装箱租赁交易平台，为用户提供俄罗斯往返中国及泛亚租箱交易服务。利用平台进口俄罗斯租箱产品超过1000条线路产品，包括提供偏点城市租箱交易服务，极大提升了租赁业务的便捷性。'
        },
        {
          image: require('../../public/static/index/BASF.png'),
          title: '巴斯夫物流容器回收管理',
          description: '巴斯夫为知名化工企业，我们为其提供多种部门级软件业务应用，物流容器回收是指巴斯夫与各客户之间的物流容器周转调度管理，业务涵盖自有容器及第三方容器，系统包含PDA端、PC-WEB端、标签打印、邮件处理等。'
        },
      ],
      logoCards:[
        { image: require('../../public/static/index/customer/01_sodexo.png') },
        { image: require('../../public/static/index/customer/02_ey.png') },
        { image: require('../../public/static/index/customer/03_microsoft.png') },
        { image: require('../../public/static/index/customer/04_deloitte.png') },
        { image: require('../../public/static/index/customer/05_suis.png') },
        { image: require('../../public/static/index/customer/06_mercedesBenz.png') },
        { image: require('../../public/static/index/customer/07_roewe.png') },
        { image: require('../../public/static/index/customer/08_supor.png') },
        { image: require('../../public/static/index/customer/09_swarovski.png') },
        { image: require('../../public/static/index/customer/10_basf.png') },
        { image: require('../../public/static/index/customer/11_zhejiang.png') },
        { image: require('../../public/static/index/customer/12_shanghaiAirport.png') },
        { image: require('../../public/static/index/customer/13_orientalYuhong.png') },
        { image: require('../../public/static/index/customer/14_michelin.png') },
        { image: require('../../public/static/index/customer/15_grundfos.png') },
        { image: require('../../public/static/index/customer/16_kimberlyClark.png') },
        { image: require('../../public/static/index/customer/17_cocaCola.png') },
        { image: require('../../public/static/index/customer/18_theGreenParty.png') },
        { image: require('../../public/static/index/customer/19_SSTM.png') },
        { image: require('../../public/static/index/customer/20_sunmi.png') },
        { image: require('../../public/static/index/customer/21_etam.png') },
        { image: require('../../public/static/index/customer/22_chjs.png') },
        { image: require('../../public/static/index/customer/23_sony.png') },
        { image: require('../../public/static/index/customer/24_anchor.png') },
        { image: require('../../public/static/index/customer/25_belle.png') },
      ],
      containerStyle:[
      ],
    };
  },
  computed: {
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    goToAnchor(anchor) {
      try {
        const element = document.querySelector(anchor);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.error(`Element with anchor ${anchor} not found`);
        }
      } catch (error) {
        console.error('Error navigating to anchor:', error);
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      const parallaxElements = document.querySelectorAll('.parallax'); // 选择所有的 .parallax 元素

      parallaxElements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          // 根据滚动位置调整背景位置
          element.style.backgroundPositionY = `${scrollPosition * 0.5}px`;
          // 或者调整内容位置
          // element.style.transform = `translateY(${scrollPosition * 0.5}px)`;
        }
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">

@use "src/assets/scss/_constant.scss";
.index-page{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: constant.$white;
  .index-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background-color: constant.$white;
    .index-header-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      max-width: 1024px;
      margin: 0 auto;
      padding: 0;
      .index-header-left{
        display: flex;
        align-items: end;
        img{
          height: 30px;
          max-width: 120px;
        }
        .index-name{
          text-align: left;
          font-family: AlibabaPuHuiTi_2_55_Regular;
          line-height: 16px;
          margin-left: 12px;
        }
      }
      .navbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        .menu-toggle {
          display: none; /* 默认隐藏菜单 */
          cursor: pointer;
          font-size: 24px;
        }
        .index-nav{
          display: flex;
          align-items: center;
          margin-bottom: 0;
          list-style-type: none;
          li{
            margin-left:28px;
            font-family: AlibabaPuHuiTi_2_55_Regular;
          }
          .menu-item{
            //border-top: 3px solid constant.$white;
            color: black;
            transition: background-color .3s;
          }
          & .menu-item:hover{
            color: constant.$primaryColor;
            cursor: pointer;
            font-family: AlibabaPuHuiTi_2_85_Bold;
          }
          & .menu-item:active{
            border-top: 3px solid constant.$primaryColor;
            color: constant.$primaryColor;
            font-weight: 600;
          }
          .index-btn{
            cursor: pointer;
            background-color: constant.$primaryColor;
            & .index-btn:hover{
              color: constant.$white;
            }
          }
        }
        .index-nav.hidden{
          display: none;
        }
      }
    }
  }
  .index-content{
    min-height: auto;
    .index-carousel{
      background-attachment: fixed;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
      position: relative;
      display: inline-block;
      width: 100%;
      img{
        width: 100%;
        display: block;
      }
      .index-carousel-text{
        max-width: 1024px;
        margin: 0 auto;
        padding: 0;
        width: 1024px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,0);
        .banner-main{
          transform: translatey(-50%);
          color: constant.$fontTitleColor;
          .banner-main-box{
            display: flex;
            align-items: center;
            font-weight: bold;
            text-align: left;
            //transform: translate(100px,0);
            span{
              font-size: 40px;
              line-height: 50px;
            }
            div{
              margin-left: 12px;
              font-size: 18px;
            }
          }
        }
        .banner-other{
          transform: translatey(-50%);
          color: constant.$white;
          text-align: left;
          font-weight: bold;
          .banner-other-title{
            font-size: 40px;
          }
          .banner-other-text{
            margin-top: 20px;
            font-size: 18px;
          }
        }
      }
    }
    .index-body-layout{
      position: relative;
    }
    .index-banner{
      position: relative;
      padding: 6% 10%;
    }
    .index-company{
      background-color: constant.$primaryColor;
      color: constant.$white;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto;
      padding: 54px 0;
      width: 100%;
      .index-company-title{
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 28px;
        font-weight: 600;
        max-width: 1024px;
      }
      .index-company-subtitle{
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-size: constant.$fontSizeBase;
        margin-top: 12px;
        max-width: 1024px;
      }
      .index-bar{
        width: 80px;
        height: 1px;
        background-color: constant.$white;
        margin: 18px 0 32px;
      }
      .index-info{
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: constant.$fontSizeSecondary;
        font-weight: 500;
        max-width: 710px;
        line-height: 30px;
        text-align: center;
        white-space: pre-wrap;
      }
    }
    .index-project-title{
      margin-top: 72px;
      margin-bottom: 20px;
      width: 130px;
      height: 18px;
      border-radius: 9px;
      background: linear-gradient(90deg, rgba(29, 80, 162, 0.11) 0%, rgba(29, 80, 162, 0) 50%, rgba(29, 80, 162, 0.11) 100%);
      span{
        max-width: 400px;
        line-height: 18px;
        color: constant.$fontTitleColor;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 28px;
        font-weight: 600;
      }
    }
    .index-project-subtitle{
      color: #888888;
      font-size: constant.$fontSizeSecondary;
      font-weight: 500;
      font-family: AlibabaPuHuiTi_2_65_Medium;
    }
    .index-project{
      position: relative;
      padding-bottom: 72px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 100%;
      .index-project-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 100px;
        text-align: justify;
        max-width: 1024px;
        .index-project-info{
          width: 36%;
          .index-project-info-name{
            color: constant.$primaryColor;
            font-family: AlibabaPuHuiTi_2_105_Heavy;
            font-size: 24px;
            font-weight: 600;
          }
          .index-project-info-desc{
            margin-top: 16px;
            color: constant.$fontHeadingColor;
            line-height: 22px;
            font-weight: 500;
            white-space: pre-wrap;
          }
        }
        .index-project-img{
          width: 40%;
          img{
            width: 400px;
          }
        }
      }
      .index-project-card{
        max-width: 1024px;
        margin: 60px auto 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 24px;
      }
      .index-project-card-row{
        max-width: 1024px;
        margin: 60px auto 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 24px;
      }
      .ant-card{
        border-radius: 0;
        box-shadow: 0 3px 9px 0 rgba(0,0,0,0.06);
        width: calc(33.33% - 24px);
        .ant-card-meta-description{
          color: constant.$fontHeadingColor;
          text-align: justify;
        }
      }
      .ant-card-hoverable:hover{
        box-shadow: 0 3px 16px 0 rgba(0,0,0,0.12);
      }
      .ant-card-bordered{
        border: none;
      }
      .ant-card-cover {
        img{
          border-radius: 0;
        }
      }
    }
    .project-bg{
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      background-color: constant.$backgroundThird;
      .index-customer-title{
        margin-top: 54px;
        color: constant.$fontTitleColor;
        font-family: AlibabaPuHuiTi_2_105_Heavy;
        font-weight: 800;
        font-size: 28px;
        line-height: 38px;
      }
      .index-customer-subtitle{
        color: constant.$fontHeadingColor;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-weight: 500;
        font-size: constant.$fontSizeBase;
        line-height: 22px;
        margin-top: 14px;
      }
      .index-customer-box{
        max-width: 1024px;
        margin: 42px auto 72px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 24px;
        .ant-card{
          width: calc(20% - 19.2px);
          height: 60px;
          border: none;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          .ant-card-body{
            padding:0;
          }
        }
        .index-customer-img{
          padding: 4px 0;
          max-width: 126px;
          max-height: 48px;
        }
        .index-customer-card{
        }
      }
    }
    .project-bg-white{
      background-color: constant.$white;
    }
  }
  .index-footer{
    background-color: #000F2A;
    padding: 50px 0 24px;
    display: flex;
    flex-direction: column;
    color: constant.$white;
    .index-footer-box{
      width: 1024px;
      max-width: 1024px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex: 1;
      .index-footer-logo{
        max-width: 84px;
      }
      .index-footer-company{
        margin-top: 14px;
        font-size: constant.$fontSizeSecondary;
      }
      .index-footer-grid{
        display: flex;
        flex-wrap: wrap;
        gap:24px;
        max-width:200px;
        text-align: left;
        div{
          width: calc(50% - 24px);
        }
      }
      .index-footer-contact{
        display: flex;
        flex-direction: column;
        //margin-left: 120px;
        .index-footer-contact-text{
          +.index-footer-contact-text{
            margin-top: 8px;
          }
        }
      }
      .index-footer-code{
        display: flex;
        flex-direction: column;
        align-items: center;
        div{
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-size: constant.$fontSizeSecondary;
        }
        img{
          margin-top: 12px;
          max-width: 92px;
        }
      }
    }
    .index-footer-number{
      margin-top: 44px;
      text-align: center;
      font-size: constant.$fontSizeSecondary;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

/* 当屏幕宽度小于1200px时 */
@media (max-width: 1200px) and (min-width: 992px) {
  .index-page{
    .index-nav.hidden{
      display: none;
    }
    .index-content{
      .index-carousel{
        .index-carousel-text{
          .banner-other{
            transform: translatey(-50%);
            color: constant.$white;
            text-align: left;
            font-weight: bold;
            .banner-other-title{
              font-size: 40px;
            }
            .banner-other-text{
              margin-top: 20px;
              font-size: 18px;
            }
          }
        }
      }
      .index-project{
        .index-project-box{
          display: flex;
          justify-content: space-evenly;
          align-items: center;
        }
        .index-project-card{
          margin: 60px 40px 0;
        }
        .index-project-card-row{
          margin: 60px 40px 0;
        }
      }
      .project-bg{
        .index-customer-box{
          max-width: 900px;
        }
      }
    }
    .index-footer{
      .index-footer-box{
        max-width: 840px;
      }
    }
  }
}
@media (max-width: 992px) and (min-width: 768px) {
  .index-page{
    .index-header{
      .index-header-box{
        display: flex;
        max-width: 640px;
        .navbar{
          .menu-toggle {
            display: block; /* 显示菜单 */
          }
          .index-nav{
            display: none; /* 隐藏导航链接 */
            flex-direction: column;
            background-color: constant.$backgroundThird;
            position: absolute;
            top: 60px;
            right: 20px;
            width: 140px;
            border-radius: 6px;
            li{
              margin: 0 14px;
              padding: 0;
            }
            & .menu-item:active{
              border-top: none;
              color: constant.$primaryColor;
              font-weight: bold;
            }
          }
          .index-nav.show{
            display: flex;
            padding: 0;
          }
          .index-nav.hidden{
            display: none;
          }
        }
      }
    }
    .index-content{
      .index-carousel{
        .index-carousel-text{
          max-width: 640px;
          width: 640px;
          .banner-main{
            .banner-main-box{
              span{
                font-size: 30px;
              }
              div{
                font-size: 14px;
              }
            }
          }
          .banner-other{
            .banner-other-title{
              font-size: 24px;
            }
            .banner-other-text{
              font-size: 14px;
            }
          }
        }
      }
      .index-company{
        padding: 32px 0;
        .index-company-title{
          font-size: 24px;
        }
        .index-company-subtitle{
          font-size: 10px;
        }
        .index-bar{
          width: 60px;
          margin: 18px 0 20px;
        }
        .index-info{
          font-size: 10px;
          max-width: 640px;
          line-height: 28px;
        }
      }
      .index-project-title{
        width: 110px;
        margin-top: 54px;
        span{
          font-size: 24px;
        }
      }
      .index-project{
        .index-project-box{
          max-width: 640px;
          margin-top: 68px;
          .index-project-info{
            width: 50%;
            .index-project-info-name{
              font-size: 20px;
            }
            .index-project-info-desc{
              font-size: 12px;
            }
          }
          .index-project-img{
            img{
              width: 260px;
            }
          }
        }
        .index-project-card{
          max-width: 640px;
          margin: 40px auto 0;
        }
        .index-project-card-row{
          max-width: 640px;
          margin: 40px auto 0;
        }
        .ant-card{
          width: calc(50% - 12px);
        }
      }
      .project-bg{
        .index-customer-box{
          max-width: 640px;
          .ant-card{
            width: calc(25% - 18px);
          }
        }
      }
    }
    .index-footer{
      .index-footer-box{
        max-width: 640px;
        .index-footer-grid{
          max-width: 160px;
        }
        .index-footer-contact{
          max-width: 160px;
          .index-footer-contact-text{
            font-size: 12px;
            +.index-footer-contact-text{
            }
          }
        }
      }
      .index-footer-number{
        margin-top: 30px;
      }
    }
  }
}
@media (max-width: 768px) and (min-width: 375px){
  .index-page{
    .ant-layout-header{
      padding-inline: 32px;
    }
    .index-header{
      .index-header-box{
        display: flex;
        flex-direction: row;
        max-width: 640px;
        .index-header-left{
          display: flex;
          flex-direction: row;
          max-width: 300px;
          .index-name{
            display: none;
          }
          img{
            height: 28px;
          }
        }
        .navbar{
          padding: 0;
          .menu-toggle {
            display: block; /* 显示菜单 */
          }
          .index-nav{
            display: none; /* 隐藏导航链接 */
            flex-direction: column;
            background-color: constant.$backgroundThird;
            position: absolute;
            top: 60px;
            right: 20px;
            width: 120px;
            border-radius: 6px;
            li{
              margin: 0 14px;
              padding: 0;
            }
            & .menu-item:active{
              border-top: none;
              color: constant.$primaryColor;
              font-weight: bold;
            }
          }
          .index-nav.show{
            display: flex;
            padding: 0;
          }
          .index-nav.hidden{
            display: none;
          }
        }
      }
    }
    .index-content{
      .slick-dots-bottom{
        bottom: -4px;
      }
      .index-carousel{
        .index-carousel-text{
          position: absolute;
          max-width: 640px;
          width: 340px;
          .banner-main{
            .banner-main-box{
              span{
                font-size: 16px;
                line-height: 23px;
              }
              div{
                font-size: 8px;
              }
            }
          }
          .banner-other{
            .banner-other-title{
              font-size: 12px;
            }
            .banner-other-text{
              font-size: 7px;
              margin-top: 4px;
            }
          }
        }
      }
      .index-company{
        padding: 24px 0;
        .index-company-title{
          font-size: 14px;
        }
        .index-company-subtitle{
          font-size: 8px;
        }
        .index-bar{
          width: 40px;
          margin: 14px 0 16px;
        }
        .index-info{
          font-size: 8px;
          max-width: 330px;
          line-height: 22px;
        }
      }
      .index-project-title{
        width: 82px;
        margin-top: 32px;
        margin-bottom: 14px;
        span{
          font-size: 16px;
        }
      }
      .index-project-subtitle{
        font-size: 9px;
      }
      .index-project{
        .index-project-box{
          flex-direction: column;
          max-width: 320px;
          margin-top: 24px;
          .index-project-info{
            width: 100%;
            .index-project-info-name{
              font-size: 14px;
            }
            .index-project-info-desc{
              font-size: 9px;
              margin-top: 12px;
              line-height: 18px;
            }
          }
          .index-project-img{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 24px;
            width: 100%;
            img{
              width: 260px;
            }
          }
        }
        .index-project-card{
          flex-direction: column;
          align-items: center;
          max-width: 640px;
          margin: 40px auto 0;
        }
        .index-project-card-row{
          max-width: 640px;
          margin: 40px auto 0;
        }
        .ant-card{
          width: 60%;
          .ant-card-meta-title{
            font-size: 14px;
          }
          .ant-card-meta-description{
            font-size: 10px;
          }
          .ant-card-body{
            padding: 18px;
          }
        }
      }
      .project-bg{
        .index-customer-title{
          margin-top: 24px;
          font-size: 16px;
        }
        .index-customer-subtitle{
          font-size: 9px;
          line-height: 9px;
          margin-top: 6px;
        }
        .index-customer-box{
          max-width: 320px;
          gap: 14px;
          margin: 24px auto 54px;
          .ant-card{
            width: calc(33.3% - 10px);
          }
          .index-customer-img{
            max-width: 80px;
          }
        }
      }
    }
    .index-footer{
      padding: 40px 0 24px;
      .index-footer-box{
        max-width: 320px;
        flex-direction: column;
        align-items: center;
        .index-footer-title{
          text-align: center;
        }
        .index-footer-grid{
          margin-top: 24px;
          max-width: 160px;
          flex-direction: column;
          text-align: center;
          div{
            width: auto;
            cursor: pointer;
          }
          & div:hover{
            color: constant.$white;
            font-weight: bold;
          }
        }
        .index-footer-contact{
          display: none;
          //max-width: 160px;
          //margin-top: 24px;
          .index-footer-contact-text{
            font-size: 12px;
            +.index-footer-contact-text{
            }
          }
        }
        .index-footer-code{
          margin-top: 24px;
        }
      }
      .index-footer-number{
        margin-top: 30px;
      }
    }
  }
}
</style>
